import * as React from 'react';

export const useWindowActiveRef = (): React.MutableRefObject<boolean> => {
  const windowActiveRef = React.useRef(true);

  const handleFocus = React.useCallback(() => {
    windowActiveRef.current = true;
  }, []);

  const handleBlur = React.useCallback(() => {
    windowActiveRef.current = false;
  }, []);

  React.useEffect(() => {
    window.addEventListener('focus', handleFocus);
    window.addEventListener('blur', handleBlur);

    return () => {
      window.removeEventListener('focus', handleFocus);
      window.removeEventListener('blur', handleBlur);
    };
    // oxlint-disable-line react/exhaustive-deps
  }, []);

  return windowActiveRef;
};
